import React, { useEffect, useState } from "react";
import { ALL_ASSIGNED_SURVEYS } from "../../GraphQL/Queries";
import { ENCRIPT_PARAMETERS } from "../../GraphQL/Mutations";
import { useMutation, useLazyQuery } from "@apollo/client";
import ViewControlMenu from "../../components/ViewControlMenu/ViewControlMenu";
import {
  FrameContainer,
  Image,
  EmptyValue,
  TextWrapper,
  LabelText,
} from "./HomeSurvey.styled";
import SurveyImage from "../../assets/svg/survey.svg";
import { NotificationManager } from "react-notifications";
import { useHistory } from "react-router-dom";
import ArrowForward from "@material-ui/icons/ArrowForwardIos";
import { Link } from "react-router-dom";

const HomeSurvey = () => {
  const history = useHistory();
  const [encriptParameters] = useMutation(ENCRIPT_PARAMETERS);
  const [surveyList, setSurveyList] = useState([]);

  const encriptParametersSurvey = (
    idSurvey,
    preview,
    idSurveyScheduling,
    isAnonymous
  ) => {
    encriptParameters({
      variables: {
        idSurvey: idSurvey.toString(),
      },
    })
      .then(
        (value) => {
          const { encriptParameters } = value.data;
          generateLinkSurvey(
            encriptParameters,
            preview,
            idSurveyScheduling,
            isAnonymous
          );
        },
        () => {
          navigator.clipboard.writeText("");
          // setAlert(false);
          // handleClick();
        }
      )
      .catch((error) => {
        const errorMessage = error.message.split("\n")[0];
        NotificationManager.error(errorMessage, "", 5000);
      });
  };

  const generateLinkSurvey = (
    encriptParameters,
    preview,
    idSurveyScheduling,
    isAnonymous
  ) => {
    console.log(encriptParameters, preview, idSurveyScheduling, isAnonymous);
    localStorage.setItem("openSurveyDate", new Date());
    if (idSurveyScheduling) {
      localStorage.setItem("idSurveyScheduling", idSurveyScheduling);
    } else {
      localStorage.setItem("idSurveyScheduling", "");
    }
    history.push(
      `/FillOutSurvey?ParamToken=${encriptParameters}&Preview=${preview}&isAnonymous=${isAnonymous}`
    );
  };

  const [runQueryAllAssignedSurveysAgent] = useLazyQuery(ALL_ASSIGNED_SURVEYS, {
    fetchPolicy: "cache-and-network",
    onCompleted: (data) => {
      console.log(data.allAssignedSurveys.nodes);
      if (data.allAssignedSurveys.nodes.lenght !== 0) {
        setSurveyList(data.allAssignedSurveys.nodes.slice(0, 3));
      } else {
        setSurveyList("Null");
      }
    },
  });

  useEffect(() => {
    runQueryAllAssignedSurveysAgent();
  }, []);

  return (
    <>
      {surveyList && surveyList.length > 0 ? (
        <FrameContainer>
          <div>
            <TextWrapper className="py-2">
              <LabelText>
                <Link to="/Survey">
                  Surveys
                  <ArrowForward />
                </Link>
              </LabelText>
            </TextWrapper>
          </div>
          <div style={{ marginTop: "65px" }}>
            <ViewControlMenu
              identity={"survey-homelist"}
              title={""}
              list={surveyList}
              isHomeSurvey={true}
              encriptParametersSurvey={encriptParametersSurvey}
              style={{ borderRadius: "8px" }}
            />
          </div>
        </FrameContainer>
      ) : (
        <FrameContainer
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <div>
            <TextWrapper className="py-2">
              {" "}
              <LabelText>
                <Link to="/Survey">
                  Surveys
                  <ArrowForward />
                </Link>
              </LabelText>
            </TextWrapper>
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Image>
              <img src={SurveyImage} alt="surveyImage"></img>
            </Image>
            <EmptyValue>
              <span className="lable1">At this moment,</span>
              <span className="lable2">you don't have pending surveys.</span>
            </EmptyValue>
          </div>
        </FrameContainer>
      )}
    </>
  );
};
export default HomeSurvey;
